// extracted by mini-css-extract-plugin
module.exports = {"hz-Listing-image-favorite-icon":"ListingFavoriteIcon_hz-Listing-image-favorite-icon__EgX3m"};